import './App.css';
import Home from './components/home.js';
import Header from './components/header.js';

function App() {

  console.log("HIRE ME! :)")
 
  return (
    <>
      <Header />
      <Home />
    </>
  );
}

export default App;
